import { locationSelectors } from "../../../common/store/slice/locationSlice";
import { questionnaireSelectors } from "../../../common/store/slice/questionnaireSlice";
import CyanButton from "../QuestionnaireButton/CyanButton";
import GreenButton from "../QuestionnaireButton/GreenButton";
import OrangeButton from "../QuestionnaireButton/OrangeButton";
import PinkButton from "../QuestionnaireButton/PinkButton";
import PurpleButton from "../QuestionnaireButton/PurpleButton";
import { QuestionnaireButtonProps } from "../QuestionnaireButton/QuestionnaireButton";
import { RegionalNamespaces } from "@pslifestyle/common/src/constants/translations";
import getCategoryFromSortKey from "@pslifestyle/common/src/helpers/getCategoryFromSortKey";
import { QuestionType } from "@pslifestyle/common/src/schemas";
import { Category } from "@pslifestyle/common/src/types/genericTypes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const ChoiceComponents: {
  [key in Category]: React.FC<QuestionnaireButtonProps>;
} = {
  housing: OrangeButton,
  transport: PurpleButton,
  food: PinkButton,
  purchases: CyanButton,
  demographic: GreenButton,
} as const;

type Props = {
  question: QuestionType;
  handleChoiceClick: (choiceText: string) => void;
};
export const MultipleChoice = ({ question, handleChoiceClick }: Props) => {
  const country = useSelector(locationSelectors.country);
  const { t } = useTranslation(RegionalNamespaces.QUESTION_AND_RECOMMENDATIONS);
  const answers = useSelector(questionnaireSelectors.answers);

  const ChoiceComponent =
    ChoiceComponents[
      getCategoryFromSortKey(question.sortKey || "01") || "demographic"
    ];

  const answerToQuestion = answers.find(
    (answer) => answer.questionId === question.id,
  );

  return (
    <div className="w-full flex flex-col items-center gap-2">
      {question.choices?.map((choice) => (
        <ChoiceComponent
          key={choice.choiceTranslationKey}
          onClick={() => handleChoiceClick(choice.choiceText ?? "")}
          choiceId={choice.choiceTranslationKey}
          active={
            !!answerToQuestion &&
            answerToQuestion.choiceText === choice.choiceText
          }
        >
          {t(`${choice.choiceTranslationKey}_${country?.code}`, {
            ns: RegionalNamespaces.QUESTION_AND_RECOMMENDATIONS,
          })}
        </ChoiceComponent>
      ))}
    </div>
  );
};
